module.exports = __webpack_public_path__ + "img/img_6659.32caf5fa.jpg";